// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --bg: #07090c;
  --bg2:#05070a;
  --card: rgba(255,255,255,0.06);
  --card2: rgba(255,255,255,0.08);
  --border: rgba(255,255,255,0.10);
  --border2: rgba(255,255,255,0.14);
  /*--text: rgba(255,255,255,0.92);*/
  --text: #B18800;
  --muted: rgba(255,255,255,0.70);
  --muted2: rgba(255,255,255,0.55);
  --shadow: 0 10px 30px rgba(0,0,0,0.45);
  --radius: 16px;
  --radius2: 22px;
}

*{ box-sizing:border-box; }
html, body { height: 100%; }

body{
  margin:0;
  color: var(--text);
  background:
    radial-gradient(1200px 500px at 20% -10%, rgba(255,255,255,0.08), transparent 0%),
    radial-gradient(900px 450px at 90% 0%, rgba(255,255,255,0.06), transparent 0%),
    linear-gradient(180deg, var(--bg), var(--bg2));
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial,
    "Apple Color Emoji","Segoe UI Emoji";
}

.page{ min-height: 100vh; }

/* App rail (your “fill browser” layout) */
.inner{
  width: min(1600px, calc(100% - 64px));
  margin: 0 auto;
}

@media (max-width: 1100px){
  .inner{
    width: min(1600px, calc(100% - 32px));
  }
}

/* Legacy container (keep if any components still use it) */
.container{
  width: min(1100px, calc(100% - 32px));
  margin: 0 auto;
  padding-bottom: 48px;
}

/* Sections */
.heroFull{
  padding: 26px 0 18px 0;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.sectionFull{
  padding: 18px 0 26px 0;
  border-top: 1px solid rgba(255,255,255,0.06);
}

/* Hero Card */
.hero{
  width: min(1100px, calc(100% - 32px));
  margin: 28px auto 20px auto;
  padding: 26px 22px;
  border: 1px solid var(--border);
  border-radius: var(--radius2);
  background: linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03));
  box-shadow: var(--shadow);
}

/* When used inside .inner to fill rail */
.heroWide{
  width: 100%;
  max-width: none;
}

.heroTop{
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.brandPill{
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: rgba(0,0,0,0.25);
  font-weight: 700;
  letter-spacing: 0.2px;
}

.heroMeta{
  font-size: 12px;
  color: var(--muted2);
}

.heroTitle{
  margin: 8px 0 6px 0;
  font-size: 34px;
  letter-spacing: -0.6px;
  line-height: 1.15;
}

.heroSubtitle{
  margin: 0 0 14px 0;
  color: var(--muted);
  font-size: 15px;
}

.heroLead{
  margin: 0 0 18px 0;
  color: var(--muted);
  line-height: 1.55;
  font-size: 14px;
  max-width: 900px;
}

.heroActions{
  display:flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btnPrimary{
  border: 1px solid var(--border2);
  background: rgba(255,255,255,0.12);
  color: var(--text);
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 700;
  cursor: pointer;
}
.btnPrimary:hover{ background: rgba(255,255,255,0.16); }

.btnGhost{
  border: 1px solid var(--border);
  background: rgba(0,0,0,0.20);
  color: var(--text);
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 700;
  cursor: pointer;
}
.btnGhost:hover{ background: rgba(0,0,0,0.30); }

/* Generic sections */
.section{ margin-top: 20px; }
.sectionHeader{ margin: 10px 0 12px 0; }
.sectionTitle{
  margin: 0 0 6px 0;
  font-size: 18px;
  letter-spacing: -0.2px;
}
.sectionDesc{
  margin: 0;
  color: var(--muted2);
  font-size: 13px;
  line-height: 1.45;
}

.grid2{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 900px){
  .grid2{ grid-template-columns: 1fr; }
}

.stack{
  display:flex;
  flex-direction: column;
  gap: 12px;
}

/* Cards */
.card{
  border: 1px solid var(--border);
  background: rgba(255,255,255,0.05);
  border-radius: var(--radius);
  padding: 14px;
  box-shadow: 0 10px 24px rgba(0,0,0,0.35);
}

.cardHeader{
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.cardTitle{
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.2px;
}

.cardTitleSm{
  font-weight: 800;
  font-size: 13px;
  margin-bottom: 8px;
  color: rgba(255,255,255,0.86);
}

.cardTag{
  font-size: 12px;
  color: var(--muted2);
  border: 1px solid var(--border);
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(0,0,0,0.18);
}

.stepTitle{
  font-weight: 800;
  margin-bottom: 8px;
  font-size: 14px;
}

.text{
  margin: 0;
  color: var(--muted);
  line-height: 1.6;
  font-size: 13.5px;
}

.bullets{
  margin: 0;
  padding-left: 18px;
  color: var(--muted);
  line-height: 1.75;
  font-size: 13.5px;
}

.callout{
  margin-top: 12px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(0,0,0,0.20);
  color: rgba(255,255,255,0.82);
  font-size: 13px;
}

.footer{
  margin-top: 18px;
  display:flex;
  justify-content: space-between;
  gap: 12px;
  color: var(--muted2);
  font-size: 12px;
  padding: 6px 2px 0 2px;
  border-top: 1px solid rgba(255,255,255,0.08);
}
.footerRight{ text-align: right; }

/* KPI formatting */
.mutedLine{
  color: rgba(255,255,255,0.70);
  font-size: 13px;
}

.alert{
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(0,0,0,0.22);
  border-radius: 14px;
  padding: 12px;
}
.alertTitle{
  font-weight: 800;
  margin-bottom: 6px;
}
.alertBody{
  color: rgba(255,255,255,0.78);
  font-size: 13px;
  line-height: 1.45;
}

.kpiGrid{
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 900px){
  .kpiGrid{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

.kpiCard{
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.04);
  border-radius: 14px;
  padding: 12px;
}

.kpiLabel{
  font-size: 12px;
  color: rgba(255,255,255,0.62);
  margin-bottom: 6px;
}

.kpiValue{
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.2px;
  color: rgba(255,255,255,0.92);
}

.kpiFooter{
  grid-column: 1 / -1;
  margin-top: 2px;
  color: rgba(255,255,255,0.55);
  font-size: 12px;
}

/* Equity chart styling */
.chartMeta{
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
}

.chartTitle{
  font-weight: 800;
  font-size: 14px;
  margin-bottom: 4px;
}

.chartRange{
  color: rgba(255,255,255,0.58);
  font-size: 12px;
}

.chartMetaRight{
  display:flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.miniStat{
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(0,0,0,0.18);
  border-radius: 14px;
  padding: 8px 10px;
  min-width: 110px;
  text-align: right;
}

.miniLabel{
  font-size: 11px;
  color: rgba(255,255,255,0.55);
  margin-bottom: 2px;
}

.miniValue{
  font-weight: 800;
  font-size: 13px;
  color: rgba(255,255,255,0.90);
}

.chartWrap{
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.03);
  border-radius: 16px;
  padding: 10px 10px 6px 10px;
  overflow: hidden;
}

/* Recharts harmonization */
.recharts-cartesian-grid line{ stroke: rgba(255,255,255,0.08); }
.recharts-text{ fill: rgba(255,255,255,0.60) !important; }
.recharts-tooltip-wrapper{ outline: none; }

/* Tables */
.tableWrap{ margin-top: 12px; }

.dataTable{
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid rgba(255,255,255,0.10);
  border-radius: 16px;
  overflow: hidden;
}

.dataTable thead th{
  text-align: left;
  padding: 10px 10px;
  color: rgba(255,255,255,0.70);
  background: rgba(0,0,0,0.22);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  font-weight: 800;
}

.dataTable tbody td{
  padding: 10px 10px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.78);
}

.dataTable tbody tr:hover{ background: rgba(255,255,255,0.04); }

.tableFootnote{
  margin-top: 8px;
  color: rgba(255,255,255,0.55);
  font-size: 12px;
}

/* Layout helpers for the “chart on right” page */
.contentGrid{
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 16px;
  align-items: start;
}

.stickyAside{
  position: sticky;
  top: 16px;
}

@media (max-width: 1100px){
  .contentGrid{ grid-template-columns: 1fr; }
  .stickyAside{ position: static; }
}

/* Performance grid */
.perfGrid{
  display:grid;
  grid-template-columns: 1.05fr 1.4fr;
  gap: 14px;
  align-items: start;
}

@media (max-width: 1100px){
  .perfGrid{ grid-template-columns: 1fr; }
}

/* Top split: left text + right chart */
.topSplit{
  display: grid;
  grid-template-columns: 1.25fr 1fr;
  gap: 14px;
  align-items: start;
}
.topLeft{ grid-column: 1; }
.topRight{ grid-column: 2; }

.topFull{
  grid-column: 1 / -1;
  margin-top: 14px;
}

@media (max-width: 1100px){
  .topSplit{ grid-template-columns: 1fr; }
  .topRight{ grid-column: 1; }
  .topFull{ grid-column: 1; }
}


/*//Updated styling for time/performance tables. */

/* ===== Regime Table Enhancements ===== */

/* Allow tables to scroll horizontally on small screens */
.tableWrap,
.dataTable {
  overflow-x: auto;
}

/* Best-performing row highlight */
.bestRow {
  background: rgba(177, 136, 0, 0.14);
}

/* Best entry emphasis */
.bestCell {
  font-weight: 900;
  color: #B18800;
}

/* Slightly tighten table spacing on smaller screens */
@media (max-width: 900px) {
  .dataTable thead th,
  .dataTable tbody td {
    padding: 8px 8px;
    font-size: 11.5px;
  }
}





.meicOverviewGrid {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(520px, 0.95fr);
  gap: 28px;
  align-items: start;
}

.meicOverviewLeft,
.meicOverviewRight {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.meicOverviewFull {
  grid-column: 1 / -1;
  min-width: 0;
}

.meicChartHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

@media (max-width: 1100px) {
  .meicOverviewGrid {
    grid-template-columns: 1fr;
  }

  .meicOverviewFull {
    grid-column: auto;
  }
}

.figureDisclaimer{
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.4;
  color: rgba(255,255,255,0.45);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA,GAAG,qBAAqB,EAAE;AAC1B,aAAa,YAAY,EAAE;;AAE3B;EACE,QAAQ;EACR,kBAAkB;EAClB;;;kDAGgD;EAChD;wCACsC;AACxC;;AAEA,OAAO,iBAAiB,EAAE;;AAE1B,0CAA0C;AAC1C;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,2DAA2D;AAC3D;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,+CAA+C;AACjD;AACA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,mFAAmF;EACnF,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,mBAAmB,kCAAkC,EAAE;;AAEvD;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,iBAAiB,4BAA4B,EAAE;;AAE/C,qBAAqB;AACrB,UAAU,gBAAgB,EAAE;AAC5B,gBAAgB,qBAAqB,EAAE;AACvC;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,QAAQ,0BAA0B,EAAE;AACtC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,4CAA4C;AAC9C;AACA,cAAc,iBAAiB,EAAE;;AAEjC,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,UAAU,gDAAgD,EAAE;AAC9D;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B,+BAA+B,8BAA8B,EAAE;AAC/D,gBAAgB,uCAAuC,EAAE;AACzD,2BAA2B,aAAa,EAAE;;AAE1C,WAAW;AACX,YAAY,gBAAgB,EAAE;;AAE9B;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA,2BAA2B,kCAAkC,EAAE;;AAE/D;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc,0BAA0B,EAAE;EAC1C,cAAc,gBAAgB,EAAE;AAClC;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,mCAAmC;EACnC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW,0BAA0B,EAAE;AACzC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,kBAAkB;AACpB;AACA,UAAU,cAAc,EAAE;AAC1B,WAAW,cAAc,EAAE;;AAE3B;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,WAAW,cAAc,EAAE;EAC3B,UAAU,cAAc,EAAE;AAC5B;;;AAGA,kDAAkD;;AAElD,0CAA0C;;AAE1C,yDAAyD;AACzD;;EAEE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;;;;;AAMA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":[":root{\n  --bg: #07090c;\n  --bg2:#05070a;\n  --card: rgba(255,255,255,0.06);\n  --card2: rgba(255,255,255,0.08);\n  --border: rgba(255,255,255,0.10);\n  --border2: rgba(255,255,255,0.14);\n  /*--text: rgba(255,255,255,0.92);*/\n  --text: #B18800;\n  --muted: rgba(255,255,255,0.70);\n  --muted2: rgba(255,255,255,0.55);\n  --shadow: 0 10px 30px rgba(0,0,0,0.45);\n  --radius: 16px;\n  --radius2: 22px;\n}\n\n*{ box-sizing:border-box; }\nhtml, body { height: 100%; }\n\nbody{\n  margin:0;\n  color: var(--text);\n  background:\n    radial-gradient(1200px 500px at 20% -10%, rgba(255,255,255,0.08), transparent 0%),\n    radial-gradient(900px 450px at 90% 0%, rgba(255,255,255,0.06), transparent 0%),\n    linear-gradient(180deg, var(--bg), var(--bg2));\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial,\n    \"Apple Color Emoji\",\"Segoe UI Emoji\";\n}\n\n.page{ min-height: 100vh; }\n\n/* App rail (your “fill browser” layout) */\n.inner{\n  width: min(1600px, calc(100% - 64px));\n  margin: 0 auto;\n}\n\n@media (max-width: 1100px){\n  .inner{\n    width: min(1600px, calc(100% - 32px));\n  }\n}\n\n/* Legacy container (keep if any components still use it) */\n.container{\n  width: min(1100px, calc(100% - 32px));\n  margin: 0 auto;\n  padding-bottom: 48px;\n}\n\n/* Sections */\n.heroFull{\n  padding: 26px 0 18px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n.sectionFull{\n  padding: 18px 0 26px 0;\n  border-top: 1px solid rgba(255,255,255,0.06);\n}\n\n/* Hero Card */\n.hero{\n  width: min(1100px, calc(100% - 32px));\n  margin: 28px auto 20px auto;\n  padding: 26px 22px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius2);\n  background: linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03));\n  box-shadow: var(--shadow);\n}\n\n/* When used inside .inner to fill rail */\n.heroWide{\n  width: 100%;\n  max-width: none;\n}\n\n.heroTop{\n  display:flex;\n  align-items:center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.brandPill{\n  display:inline-flex;\n  align-items:center;\n  gap:8px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--border);\n  background: rgba(0,0,0,0.25);\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.heroMeta{\n  font-size: 12px;\n  color: var(--muted2);\n}\n\n.heroTitle{\n  margin: 8px 0 6px 0;\n  font-size: 34px;\n  letter-spacing: -0.6px;\n  line-height: 1.15;\n}\n\n.heroSubtitle{\n  margin: 0 0 14px 0;\n  color: var(--muted);\n  font-size: 15px;\n}\n\n.heroLead{\n  margin: 0 0 18px 0;\n  color: var(--muted);\n  line-height: 1.55;\n  font-size: 14px;\n  max-width: 900px;\n}\n\n.heroActions{\n  display:flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.btnPrimary{\n  border: 1px solid var(--border2);\n  background: rgba(255,255,255,0.12);\n  color: var(--text);\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.btnPrimary:hover{ background: rgba(255,255,255,0.16); }\n\n.btnGhost{\n  border: 1px solid var(--border);\n  background: rgba(0,0,0,0.20);\n  color: var(--text);\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.btnGhost:hover{ background: rgba(0,0,0,0.30); }\n\n/* Generic sections */\n.section{ margin-top: 20px; }\n.sectionHeader{ margin: 10px 0 12px 0; }\n.sectionTitle{\n  margin: 0 0 6px 0;\n  font-size: 18px;\n  letter-spacing: -0.2px;\n}\n.sectionDesc{\n  margin: 0;\n  color: var(--muted2);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.grid2{\n  display:grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n@media (max-width: 900px){\n  .grid2{ grid-template-columns: 1fr; }\n}\n\n.stack{\n  display:flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Cards */\n.card{\n  border: 1px solid var(--border);\n  background: rgba(255,255,255,0.05);\n  border-radius: var(--radius);\n  padding: 14px;\n  box-shadow: 0 10px 24px rgba(0,0,0,0.35);\n}\n\n.cardHeader{\n  display:flex;\n  align-items:center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.cardTitle{\n  font-weight: 800;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n}\n\n.cardTitleSm{\n  font-weight: 800;\n  font-size: 13px;\n  margin-bottom: 8px;\n  color: rgba(255,255,255,0.86);\n}\n\n.cardTag{\n  font-size: 12px;\n  color: var(--muted2);\n  border: 1px solid var(--border);\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(0,0,0,0.18);\n}\n\n.stepTitle{\n  font-weight: 800;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.text{\n  margin: 0;\n  color: var(--muted);\n  line-height: 1.6;\n  font-size: 13.5px;\n}\n\n.bullets{\n  margin: 0;\n  padding-left: 18px;\n  color: var(--muted);\n  line-height: 1.75;\n  font-size: 13.5px;\n}\n\n.callout{\n  margin-top: 12px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(255,255,255,0.12);\n  background: rgba(0,0,0,0.20);\n  color: rgba(255,255,255,0.82);\n  font-size: 13px;\n}\n\n.footer{\n  margin-top: 18px;\n  display:flex;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--muted2);\n  font-size: 12px;\n  padding: 6px 2px 0 2px;\n  border-top: 1px solid rgba(255,255,255,0.08);\n}\n.footerRight{ text-align: right; }\n\n/* KPI formatting */\n.mutedLine{\n  color: rgba(255,255,255,0.70);\n  font-size: 13px;\n}\n\n.alert{\n  border: 1px solid rgba(255,255,255,0.14);\n  background: rgba(0,0,0,0.22);\n  border-radius: 14px;\n  padding: 12px;\n}\n.alertTitle{\n  font-weight: 800;\n  margin-bottom: 6px;\n}\n.alertBody{\n  color: rgba(255,255,255,0.78);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.kpiGrid{\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n@media (max-width: 900px){\n  .kpiGrid{ grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n.kpiCard{\n  border: 1px solid rgba(255,255,255,0.10);\n  background: rgba(255,255,255,0.04);\n  border-radius: 14px;\n  padding: 12px;\n}\n\n.kpiLabel{\n  font-size: 12px;\n  color: rgba(255,255,255,0.62);\n  margin-bottom: 6px;\n}\n\n.kpiValue{\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.2px;\n  color: rgba(255,255,255,0.92);\n}\n\n.kpiFooter{\n  grid-column: 1 / -1;\n  margin-top: 2px;\n  color: rgba(255,255,255,0.55);\n  font-size: 12px;\n}\n\n/* Equity chart styling */\n.chartMeta{\n  display:flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.chartTitle{\n  font-weight: 800;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.chartRange{\n  color: rgba(255,255,255,0.58);\n  font-size: 12px;\n}\n\n.chartMetaRight{\n  display:flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.miniStat{\n  border: 1px solid rgba(255,255,255,0.10);\n  background: rgba(0,0,0,0.18);\n  border-radius: 14px;\n  padding: 8px 10px;\n  min-width: 110px;\n  text-align: right;\n}\n\n.miniLabel{\n  font-size: 11px;\n  color: rgba(255,255,255,0.55);\n  margin-bottom: 2px;\n}\n\n.miniValue{\n  font-weight: 800;\n  font-size: 13px;\n  color: rgba(255,255,255,0.90);\n}\n\n.chartWrap{\n  border: 1px solid rgba(255,255,255,0.10);\n  background: rgba(255,255,255,0.03);\n  border-radius: 16px;\n  padding: 10px 10px 6px 10px;\n  overflow: hidden;\n}\n\n/* Recharts harmonization */\n.recharts-cartesian-grid line{ stroke: rgba(255,255,255,0.08); }\n.recharts-text{ fill: rgba(255,255,255,0.60) !important; }\n.recharts-tooltip-wrapper{ outline: none; }\n\n/* Tables */\n.tableWrap{ margin-top: 12px; }\n\n.dataTable{\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  border: 1px solid rgba(255,255,255,0.10);\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.dataTable thead th{\n  text-align: left;\n  padding: 10px 10px;\n  color: rgba(255,255,255,0.70);\n  background: rgba(0,0,0,0.22);\n  border-bottom: 1px solid rgba(255,255,255,0.08);\n  font-weight: 800;\n}\n\n.dataTable tbody td{\n  padding: 10px 10px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  color: rgba(255,255,255,0.78);\n}\n\n.dataTable tbody tr:hover{ background: rgba(255,255,255,0.04); }\n\n.tableFootnote{\n  margin-top: 8px;\n  color: rgba(255,255,255,0.55);\n  font-size: 12px;\n}\n\n/* Layout helpers for the “chart on right” page */\n.contentGrid{\n  display: grid;\n  grid-template-columns: 1.6fr 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.stickyAside{\n  position: sticky;\n  top: 16px;\n}\n\n@media (max-width: 1100px){\n  .contentGrid{ grid-template-columns: 1fr; }\n  .stickyAside{ position: static; }\n}\n\n/* Performance grid */\n.perfGrid{\n  display:grid;\n  grid-template-columns: 1.05fr 1.4fr;\n  gap: 14px;\n  align-items: start;\n}\n\n@media (max-width: 1100px){\n  .perfGrid{ grid-template-columns: 1fr; }\n}\n\n/* Top split: left text + right chart */\n.topSplit{\n  display: grid;\n  grid-template-columns: 1.25fr 1fr;\n  gap: 14px;\n  align-items: start;\n}\n.topLeft{ grid-column: 1; }\n.topRight{ grid-column: 2; }\n\n.topFull{\n  grid-column: 1 / -1;\n  margin-top: 14px;\n}\n\n@media (max-width: 1100px){\n  .topSplit{ grid-template-columns: 1fr; }\n  .topRight{ grid-column: 1; }\n  .topFull{ grid-column: 1; }\n}\n\n\n/*//Updated styling for time/performance tables. */\n\n/* ===== Regime Table Enhancements ===== */\n\n/* Allow tables to scroll horizontally on small screens */\n.tableWrap,\n.dataTable {\n  overflow-x: auto;\n}\n\n/* Best-performing row highlight */\n.bestRow {\n  background: rgba(177, 136, 0, 0.14);\n}\n\n/* Best entry emphasis */\n.bestCell {\n  font-weight: 900;\n  color: #B18800;\n}\n\n/* Slightly tighten table spacing on smaller screens */\n@media (max-width: 900px) {\n  .dataTable thead th,\n  .dataTable tbody td {\n    padding: 8px 8px;\n    font-size: 11.5px;\n  }\n}\n\n\n\n\n\n.meicOverviewGrid {\n  width: 100%;\n  max-width: 1540px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(520px, 0.95fr);\n  gap: 28px;\n  align-items: start;\n}\n\n.meicOverviewLeft,\n.meicOverviewRight {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.meicOverviewFull {\n  grid-column: 1 / -1;\n  min-width: 0;\n}\n\n.meicChartHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 1100px) {\n  .meicOverviewGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .meicOverviewFull {\n    grid-column: auto;\n  }\n}\n\n.figureDisclaimer{\n  margin-top: 6px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: rgba(255,255,255,0.45);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
